<template>
  <div class="row g-2 justify-content-center my-5">
    <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11">
      <h1>Bahn-Vorhersage Blog</h1>
      <p>
        An dieser Stelle werden wir in Zukunft immer über die Entwicklung von Bahn-Vorhersage
        berichten sowie generell über Themen im Bereich ÖPNV, Verspätungen und deren Vorhersage.
      </p>
      <h2>Blogbeiträge</h2>
      <div class="card my-4">
        <div class="card-header">
          4. November 2026 von Theo Döllmann <span class="text-muted">(English)</span>
        </div>
        <div class="card-body">
          <h5 class="card-title">Scaling Bahn-Vorhersage to the World using Transitous</h5>
          <p>
            How I plan to scale Bahn-Vorhersage to the world using Transitous, and what I have
            learned about train delay prediction along the way.
          </p>
          <NuxtLink to="/blog/transitous-plans" class="btn btn-primary">To the Blog Post</NuxtLink>
        </div>
      </div>

      <div class="card my-4">
        <div class="card-header">2. Oktober 2026 von Theo Döllmann</div>
        <div class="card-body">
          <h5 class="card-title">Zugverbindungen teilen (powered by Typst)</h5>
          <p>
            Wie Typst dabei hilft, Zugverbindungen besser zu teilen, als es der DB-Navigator macht.
          </p>
          <NuxtLink to="/blog/journey-sharing" class="btn btn-primary">Zum Blogbeitrag</NuxtLink>
        </div>
      </div>
      <div class="card my-4">
        <div class="card-header">22. Januar 2026 von Theo Döllmann</div>
        <div class="card-body">
          <h5 class="card-title">Welcher Bahnhof ist der Richtige?</h5>
          <p>
            Wie entscheiden wir, welcher Bahnhof von Berlin Hbf, Berlin Hbf (tief) und Berlin Hbf
            (S-Bahn) in der Bahnhofssuche angezeigt wird? Ein Blick hinter die Kulissen.
          </p>
          <NuxtLink to="/blog/meta-bahnhoefe" class="btn btn-primary">Zum Blogbeitrag</NuxtLink>
        </div>
      </div>
      <div class="card my-4">
        <div class="card-header">21. Juli 2025 von Theo Döllmann</div>
        <div class="card-body">
          <h5 class="card-title">Generalsanierung Riedbahn</h5>
          <p>
            Wie hat sich die Verspätung auf der Riedbahn seit der Generalsanierung entwickelt? Wir
            analysieren die Daten.
          </p>
          <NuxtLink to="/blog/riedbahn-generalsanierung" class="btn btn-primary"
            >Zum Blogbeitrag</NuxtLink
          >
        </div>
      </div>
      <div class="card my-4">
        <div class="card-header">9. März 2025 von Theo Döllmann</div>
        <div class="card-body">
          <h5 class="card-title">Verspätungsverteilungen zeigen</h5>
          <p>
            Was sagen die Histogramme in der Verbindungsansicht über die Ankunfts- und
            Abfahrtszeiten der Züge aus? In diesem Blogbeitrag gehen wir auf die Details dahinter
            ein.
          </p>
          <NuxtLink to="/blog/time-histograms" class="btn btn-primary">Zum Blogbeitrag</NuxtLink>
        </div>
      </div>
      <h2>Call for Participation</h2>
      <p>
        Falls du selbst etwas beitragen kannst und möchtest, zum Beispiel weil du auf diesem Gebiet
        forschst oder ein eigenes Projekt betreibst, dann erstelle gerne ein
        <a
          href="https://gitlab.com/bahnvorhersage/bahnvorhersage_frontend/-/issues"
          target="_blank"
          rel="noopener noreferrer"
          >Issue auf GitLab</a
        >. Beschreibe am besten kurz, wer du bist und worüber du schreiben möchtest, und ich melde
        mich dann schnellstmöglich bei dir, ob und wie das möglich ist.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'default' })

useHead({
  title: 'Blog',
  meta: [
    {
      name: 'description',
      content: 'Blog von Bahn-Vorhersage. Hier wird rund um das Thema berichtet.'
    }
  ]
})
</script>
